var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aside"},[_c('changerole'),_c('el-menu',{attrs:{"router":""},on:{"select":_vm.handleSelect}}),_c('div',{staticClass:"back"},[_c('img',{attrs:{"src":require("../../assets/icon/退出.png"),"height":"20","width":"20"},on:{"click":_vm.logout}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }